/** @jsx h */
import { h } from 'preact'
import { useEffect, useState } from 'preact/compat'
import './main.css'
import Appointment from './components/appointment'

import { getMaisonConfig, getAllCountries, getPhonesValidation } from './api'

import { GlobalProvider } from './use-global'
import { LabelProvider } from './use-label'

const App = ({
  selector,
  maisonId,
  apiBaseUrl,
  country,
  boutiqueId,
  homeLink,
  locale,
  product,
  useAnalytics,
  analyticsDriver,
  tcId,
  analyticsCountry,
  analyticsLocale,
  internalComments,
  showPrintIcon,
  direction,
  context,
  source,
  colors,
  onSectionExpanded
}) => {
  const [conf, setConf] = useState()
  const [countries, setCountries] = useState()
  const [phonesValidation, setPhonesValidation] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    Promise.all([
      getMaisonConfig({ apiBaseUrl, maisonId, language: locale }),
      getAllCountries({ apiBaseUrl, language: locale }),
      getPhonesValidation({ apiBaseUrl })
    ])
      .then(values => {
        setConf(values[0])
        setCountries(values[1])
        setPhonesValidation(values[2])
      })
      .catch(err => {
        // todo handle error
        console.log(err)
        setError(true)
      })
  }, [locale, maisonId, apiBaseUrl])

  if (error) {
    return (
      <div className='rcc-font-widget'>
        <p className='rcc-text-center rcc-m-0 rcc-mb-2 rcc-text-1xl rcc-uppercase'>Sorry</p>
        <p className='rcc-text-center rcc-text-sm rcc-m-0'>
          This page is temporarily unavailable, we are working on it.
        </p>
        <p className='rcc-text-center rcc-text-sm rcc-m-0'>Please try again later or contact us by phone. Thank you.</p>
      </div>
    )
  }

  return (
    <div className='RCCanvasWidget'>
      {conf && countries ? (
        <GlobalProvider
          canvasConfig={{
            selector,
            maisonId,
            apiBaseUrl,
            country,
            boutiqueId,
            homeLink,
            locale,
            product,
            useAnalytics,
            analyticsDriver,
            tcId,
            analyticsCountry,
            analyticsLocale,
            internalComments,
            showPrintIcon,
            direction,
            context,
            source,
            colors,
            onSectionExpanded
          }}
          maisonConfig={{
            ...conf.configurations,
            countriesConfig: conf.enabledCountries.map(ec => ec)
          }}
        >
          <LabelProvider labels={conf.labels}>
            <Appointment conf={conf} countries={countries} phoneValidation={phonesValidation} />
          </LabelProvider>
        </GlobalProvider>
      ) : null}
    </div>
  )
}

export default App
